import PropTypes from 'prop-types';
import CloseIconSmall from '../assets/ai/CloseIconSmall';

const WelcomeBubble = ({ isClosing, onClose, onClick }) => {
  const bubbleEnterStyle = {
    animation: 'slideInAndGrow 1600ms ease-out',
    transformOrigin: 'right',
  };

  const bubbleExitStyle = {
    animation: 'slideOutAndShrink 1000ms ease-in forwards',
    transformOrigin: 'right',
    animationFillMode: 'forwards',
  };

  return (
    <>
      <style>
        {`
          @keyframes slideInAndGrow {
            from {
              opacity: 0;
              transform: translateX(12px);
            }
            60% {
              opacity: 1;
            }
            to {
              opacity: 1;
              transform: translateX(0);
            }
          }

          @keyframes slideOutAndShrink {
            from {
              opacity: 1;
            }
            5% {
              opacity: 0;
            }
            to {
              opacity: 0;
            }
          }
        `}
      </style>

      <div
        className="tw-relative -tw-mt-[10px] tw-mr-3 tw-flex tw-items-center"
        style={isClosing ? bubbleExitStyle : bubbleEnterStyle}
      >
        <div
          onClick={onClick}
          className="tw-relative tw-cursor-pointer tw-rounded-[16px] tw-bg-mainOrange tw-px-4 tw-py-[30px] md:tw-pl-[25px] md:tw-pr-[36px]"
          role="button"
          tabIndex={0}
          onKeyDown={e => {
            if (e.key === 'Enter' || e.key === ' ') {
              onClick();
            }
          }}
        >
          <button
            type="button"
            onClick={e => {
              e.stopPropagation();
              onClose();
            }}
            className="tw-absolute -tw-right-4 -tw-top-4 tw-z-10 tw-flex tw-h-8 tw-w-8 tw-items-center tw-justify-center tw-rounded-full tw-bg-black tw-text-white tw-transition-colors hover:tw-bg-gray-800"
            title="Закрити"
          >
            <CloseIconSmall />
          </button>
          <div className="tw-font-grotesk tw-text-[14px] tw-font-medium tw-text-white md:tw-text-[16px]">
            Привіт! Чим можу допомогти?
          </div>
          <div className="tw-absolute -tw-right-[15px] tw-top-[60%] tw-h-0 tw-w-0 -tw-translate-y-1/2 tw-border-b-[12px] tw-border-l-[22px] tw-border-t-[12px] tw-border-b-transparent tw-border-l-mainOrange tw-border-t-transparent"></div>
        </div>
      </div>
    </>
  );
};

WelcomeBubble.propTypes = {
  isClosing: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onClick: PropTypes.func.isRequired,
};

export default WelcomeBubble;
